var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{attrs:{"type":_vm.type,"invert":_vm.invert,"loading":_vm.loading,"icon":_vm.icon,"padding":_vm.padding,"bold":_vm.bold,"block":_vm.block,"size":_vm.size},on:{"click":_vm.handleClicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }